export default "__VITE_ASSET__CzyTF56L__"